/**
 * Filter Vagas — Trabalhe Conosco Supperfrigo
 *
 * Lista todas as vagas no boot. Selects Área + UF e busca textual filtram.
 * CTA "Quero essa vaga": scroll suave até o form + pré-seleciona vaga no
 * select for-vaga do CF7 (encoded como `slug|titulo — cidade-uf`).
 */
(function ($) {
    'use strict';

    // Remove acentos e caracteres combinantes pra busca ser insensível a acentuação
    function stripAccents(str) {
        return (str || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    $(function () {
        var $page = $('.page-trabalhe-conosco');
        if (!$page.length) return;

        var $area     = $page.find('[data-vagas-filter="area"]');
        var $uf       = $page.find('[data-vagas-filter="uf"]');
        var $search   = $page.find('[data-vagas-filter="search"]');
        var $reset    = $page.find('[data-vagas-reset]');
        var $list     = $page.find('[data-vagas-list]');
        var $cards    = $page.find('[data-vaga]');
        var $count    = $page.find('[data-vagas-count]');
        var $countVal = $page.find('[data-vagas-count-value]');
        var $plurals  = $page.find('[data-vagas-count-plural]');
        var $noResults = $page.find('[data-vagas-noresults]');

        function applyFilter() {
            var areaVal = ($area.val() || '').trim();
            var ufVal   = ($uf.val() || '').trim();
            var qVal    = stripAccents(($search.val() || '').trim().toLowerCase());

            var matched = 0;
            $cards.each(function () {
                var $card = $(this);
                var cardArea = ($card.data('area')   || '').toString();
                var cardUf   = ($card.data('uf')     || '').toString();
                var cardTxt  = stripAccents(($card.data('search') || '').toString().toLowerCase());

                var matchArea = areaVal === '' || cardArea === areaVal;
                var matchUf   = ufVal   === '' || cardUf   === ufVal;
                var matchQ    = qVal    === '' || cardTxt.indexOf(qVal) !== -1;

                if (matchArea && matchUf && matchQ) {
                    $card.removeAttr('hidden');
                    matched++;
                } else {
                    $card.attr('hidden', true);
                }
            });

            if (matched > 0) {
                $list.removeAttr('hidden');
                $count.removeAttr('hidden');
                $noResults.attr('hidden', true);
                $countVal.text(matched);
                $plurals.text(matched === 1 ? '' : 's');
            } else {
                $list.attr('hidden', true);
                $count.attr('hidden', true);
                $noResults.removeAttr('hidden');
            }
        }

        $area.on('change', applyFilter);
        $uf.on('change', applyFilter);
        $search.on('input', applyFilter);

        $reset.on('click', function () {
            $area.val('');
            $uf.val('');
            $search.val('');
            applyFilter();
        });

        // Normaliza string pro match de vaga: lowercase, em-dash → hífen, colapsa espaços
        function normalizeVaga(str) {
            return (str || '')
                .toString()
                .toLowerCase()
                .replace(/[–—]/g, '-')
                .replace(/\s+/g, ' ')
                .trim();
        }

        // CTA "Quero essa vaga" → scroll suave ao form + pré-seleciona no select CF7
        $page.on('click', '[data-vaga-apply]', function (e) {
            e.preventDefault();
            var vagaValue = normalizeVaga($(this).data('vaga-apply'));
            var $select = $page.find('select[name="for-vaga"], select[name="for-vaga[]"]').first();
            var matched = false;

            if ($select.length && vagaValue) {
                $select.find('option').each(function () {
                    var optTxt = normalizeVaga($(this).text());
                    if (optTxt === vagaValue) {
                        $select.val($(this).val()).trigger('change');
                        matched = true;
                        return false;
                    }
                });

                // Fallback: contains se não bater exato
                if (!matched) {
                    $select.find('option').each(function () {
                        var optTxt = normalizeVaga($(this).text());
                        if (optTxt.indexOf(vagaValue) !== -1 || vagaValue.indexOf(optTxt) !== -1) {
                            $select.val($(this).val()).trigger('change');
                            matched = true;
                            return false;
                        }
                    });
                }
            }

            var $target = $('#candidatura');
            if ($target.length) {
                $('html, body').animate({
                    scrollTop: $target.offset().top - 40
                }, 500);
            }
        });

        applyFilter();
    });
})(jQuery);
